(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target.closest('.contact-form__form');
    if (!form) return;

    var checkbox = form.querySelector('[data-accepts-marketing]');
    if (!checkbox || !checkbox.checked) return;

    var emailField = form.querySelector('input[name="contact[email]"]');
    if (!emailField || !emailField.value) return;

    var body = new URLSearchParams({
      form_type: 'customer',
      utf8: '✓',
      'contact[email]': emailField.value
    });

    fetch('/contact#footer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
      keepalive: true
    });
  });
  } catch(e) { console.error(e); }
})();

})();
